























import {Vue, Component, Prop} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';

@Component({
    name: 'MediumPost',
    components: {AppLink},
})
export default class MediumPost extends Vue {
    @Prop({required: true}) public title!: string;
    @Prop({required: true}) public description!: string;
    @Prop({required: true}) public href!: string;
    @Prop({required: true}) public image!: string;
}
